import { VerifiedUser } from '@mui/icons-material'
import i18n from 'i18next';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const getKYCManagement = () => ({
    id: 'kycManagement',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'kycManagement',
            title: i18n.t('sidemenu.kycManagement'),
            type: 'item',
            url: '/kycManagement',
            icon: VerifiedUser,
            breadcrumbs: false
        },
       
    ]
});

export default getKYCManagement;

